import React from 'react';

// Types
import { CreateAccountFlowType } from './types';

// Components
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';
import SignUpTermsAgreement from 'Shared/components/SignUpTermsAgreement/SignUpTermsAgreement';
import SignUpPerformForm from './SignUpPerformForm';
import SignUpPIForm from './SignUpPIForm';

// Styles
import './SignUpBody.scss';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

type Props = {
  flowType: CreateAccountFlowType;
  askForName?: boolean;
  isPiCompany?: boolean;
  askForRole?: boolean;
  title?: string;
  subTitle?: string;
  inviterSlug?: string;
  workspaceSlug?: string;
  currentEmail?: string;
  invitationToken?: string;
  withCalendar?: boolean;
};

const SignUpBody = ({
  flowType,
  askForName = false,
  askForRole = false,
  isPiCompany = false,
  title = 'Sign up for PI Perform',
  subTitle = 'Start your free trial today. No credit card required.',
  inviterSlug,
  workspaceSlug,
  currentEmail,
  invitationToken,
  withCalendar = true,
}: Props) => {
  const {
    app: {
      routes: { signInUrl },
    },
  } = useApp();

  const baseClassName = 'SignUpBody';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__header`}>
        <p className={`${baseClassName}__signin-link`}>
          Already have an account?&nbsp;&nbsp;
          <a href={`${signInUrl}${inviterSlug ? `?inviter_slug=${inviterSlug}` : ''}`}>Sign in</a>
        </p>
      </div>
      <div className={`${baseClassName}__content`}>
        <div className={`${baseClassName}__content__form`}>
          <WpIllustration
            src={Illustrations.pi_logo_full_red_with_text}
            className={`${baseClassName}__content__logo`}
            alt="Predictive Index logo"
          />
          <h1 className={`${baseClassName}__title`}>{title}</h1>
          <div className={`${baseClassName}__sub-title`}>{subTitle}</div>
          {isPiCompany ? (
            <SignUpPIForm
              inviterSlug={inviterSlug}
              workspaceSlug={workspaceSlug}
              currentEmail={currentEmail}
              invitationToken={invitationToken}
            />
          ) : (
            <SignUpPerformForm
              flowType={flowType}
              askForName={askForName}
              askForRole={askForRole}
              inviterSlug={inviterSlug}
              workspaceSlug={workspaceSlug}
              currentEmail={currentEmail}
              invitationToken={invitationToken}
              withCalendar={withCalendar}
            />
          )}
        </div>
      </div>
      <SignUpTermsAgreement className={`${baseClassName}__footer`} />
    </div>
  );
};

export default SignUpBody;
